// extracted by mini-css-extract-plugin
module.exports = {"container":"Category_container__29ekf","name":"Category_name__24iAB"};